/* ========= BLS – Affirmation (scoped + crash-proof) ========= */

const RAPIDAPI_KEY = "38a0bf813emsh1d79864bcba5effp1d4e18jsnc929ab71ea81";

const BACKGROUND_IMAGES = [
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/Mushrooms.png?v=1761614055",
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/pinkflowers.png?v=1761614055",
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/Fairyfield.png?v=1761614054",
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/TieDie.png?v=1761659521",
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/TealTan.png?v=1761659612",
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/Rust.png?v=1761659709",
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/Grunge3.png?v=1761659849"
];

const MUSIC_TRACKS = [
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/MA_OlegKashchenko_ShiningLife_Short_1_00.wav?v=1761672816",
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/MA_E2YOU_RadiantSmiles_60s.wav?v=1761672777",
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/MA_CrankMusic_VictoryAnthem_Medium.wav?v=1761672746",
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/Have_Fun_0.41.mp3?v=1761672711",
  "https://cdn.shopify.com/s/files/1/0766/5051/2700/files/Advertising_Inspiration_Edit01.mp3?v=1761672690"
];

const NS = "BLSv8_";
const KEYS = {
  AFFIRMATION: NS + "affirmation",
  DATE:        NS + "date",
  BG:          NS + "bg",
  MUSIC:       NS + "music",
};
const today = new Date().toDateString();

/* ---------- Safe helpers ---------- */
function qs(sel, root) {
  // Accept CSS selector string or a Node; always return an Element or null
  if (!sel) return null;
  if (sel.nodeType === 1) return sel;
  const base = root && root.nodeType === 1 ? root : document;
  return base.querySelector(sel);
}
function qid(id) {
  return document.getElementById(id);
}

// Storage shim that survives sandboxed previews
const safeStorage = (() => {
  try {
    const testKey = "__bls_test__";
    window.localStorage.setItem(testKey, "1");
    window.localStorage.removeItem(testKey);
    return {
      getItem: (k) => window.localStorage.getItem(k),
      setItem: (k, v) => window.localStorage.setItem(k, v),
      removeItem: (k) => window.localStorage.removeItem(k),
    };
  } catch {
    const mem = {};
    return {
      getItem: (k) => (k in mem ? mem[k] : null),
      setItem: (k, v) => { mem[k] = String(v); },
      removeItem: (k) => { delete mem[k]; },
    };
  }
})();

function pickDailyIndex(len) {
  let h = 0;
  for (let i = 0; i < today.length; i++) h = (h * 31 + today.charCodeAt(i)) >>> 0;
  return len ? (h % len) : 0;
}
function nextDifferent(len, avoid) {
  if (len <= 1) return 0;
  const step = 1 + Math.floor(Math.random() * (len - 1));
  return ((avoid < 0 ? 0 : avoid) + step) % len;
}

/* ---------- App boot (scoped) ---------- */
function boot() {
  const app = qid("affirmation-app");
  if (!app) return; // Not on the affirmation page

  const bgEl     = qid("bg");
  const affEl    = qid("affirmation");
  const shareBtn = qid("share");
  const toggle   = qid("musicToggle");
  const refresh  = qid("refresh");
  const label    = qid("trackLabel");
  const audio    = qid("bgMusic");

  let currentBgIdx = -1;
  let currentTrackIdx = -1;

  function setBackground(url) {
    if (bgEl && url) bgEl.style.backgroundImage = `url("${url}")`;
  }

  function loadDailyBackground() {
    let stored = safeStorage.getItem(KEYS.BG);
    let d = safeStorage.getItem(KEYS.DATE);
    if (!stored || d !== today) {
      currentBgIdx = pickDailyIndex(BACKGROUND_IMAGES.length);
      stored = BACKGROUND_IMAGES[currentBgIdx];
      safeStorage.setItem(KEYS.BG, stored);
      safeStorage.setItem(KEYS.DATE, today);
    } else {
      const plain = stored.split("/").pop().split("?")[0];
      const idx = BACKGROUND_IMAGES.findIndex(u => u.includes(plain));
      currentBgIdx = idx >= 0 ? idx : 0;
    }
    setBackground(stored);
  }

  function setMusic(url) {
    if (audio) audio.src = url;
    if (label) {
      const nice = decodeURIComponent(url.split("/").pop())
        .replace(/\?.*$/, "")
        .replace(/[_-]/g, " ")
        .replace(/\.(mp3|wav|m4a)$/i, "");
      label.textContent = `Now queued: ${nice}`;
    }
  }

  function loadDailyMusic() {
    let stored = safeStorage.getItem(KEYS.MUSIC);
    let d = safeStorage.getItem(KEYS.DATE);
    if (!stored || d !== today) {
      currentTrackIdx = pickDailyIndex(MUSIC_TRACKS.length);
      stored = MUSIC_TRACKS[currentTrackIdx];
      safeStorage.setItem(KEYS.MUSIC, stored);
      safeStorage.setItem(KEYS.DATE, today);
    } else {
      const plain = stored.split("/").pop().split("?")[0];
      const idx = MUSIC_TRACKS.findIndex(u => u.includes(plain));
      currentTrackIdx = idx >= 0 ? idx : 0;
    }
    setMusic(stored);
  }

  async function getAffirmation() {
    try {
      const res = await fetch(
        "https://affirmations-api-by-apirobots.p.rapidapi.com/v1/affirmations/random",
        {
          method: "GET",
          headers: {
            "x-rapidapi-host": "affirmations-api-by-apirobots.p.rapidapi.com",
            "x-rapidapi-key": RAPIDAPI_KEY,
          },
        }
      );
      const data = await res.json();
      return data?.affirmation || "You are strong, creative, and capable.";
    } catch {
      return "You are strong, creative, and capable.";
    }
  }

  async function getAffirmationFresh() {
    try {
      const res = await fetch(
        "https://affirmations-api-by-apirobots.p.rapidapi.com/v1/affirmations/random?ts=" + Date.now(),
        {
          method: "GET",
          cache: "no-store",
          headers: {
            "pragma": "no-cache",
            "cache-control": "no-cache",
            "x-rapidapi-host": "affirmations-api-by-apirobots.p.rapidapi.com",
            "x-rapidapi-key": RAPIDAPI_KEY,
          },
        }
      );
      const data = await res.json();
      return data?.affirmation || null;
    } catch {
      return null;
    }
  }

  async function displayAffirmation() {
    let a = safeStorage.getItem(KEYS.AFFIRMATION);
    let d = safeStorage.getItem(KEYS.DATE);
    if (!a || d !== today) {
      a = await getAffirmation();
      safeStorage.setItem(KEYS.AFFIRMATION, a);
      safeStorage.setItem(KEYS.DATE, today);
    }
    if (affEl) affEl.textContent = `"${a}"`;

    if (shareBtn) {
      shareBtn.onclick = async () => {
        const text = `My affirmation today from Blended Lines Studios: "${a}" ✨`;
        const url = window.location.href.replace(/(\?|&)preview_theme_id=\d+/, "");
        try {
          if (navigator.share) {
            await navigator.share({ title: "Daily Affirmation 🌿", text, url });
            return;
          }
        } catch {}
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(`${text} ${url}`);
          alert("Copied! You can now paste and share it anywhere 💫");
        }
      };
    }
  }

  async function refreshInspiration() {
    // BG
    currentBgIdx = nextDifferent(BACKGROUND_IMAGES.length, currentBgIdx);
    const newBg = BACKGROUND_IMAGES[currentBgIdx];
    safeStorage.setItem(KEYS.BG, newBg);
    setBackground(newBg);

    // Music
    currentTrackIdx = nextDifferent(MUSIC_TRACKS.length, currentTrackIdx);
    const newTrack = MUSIC_TRACKS[currentTrackIdx];
    safeStorage.setItem(KEYS.MUSIC, newTrack);
    setMusic(newTrack);

    if (audio && !audio.paused) {
      audio.pause();
      if (toggle) {
        toggle.textContent = "🎵 Play Music";
        toggle.classList.remove("btn-primary");
        toggle.classList.add("btn-ghost");
      }
    }

    // Affirmation
    const before = (affEl?.textContent || "").replace(/^"|"$|^\s+|\s+$/g, "");
    let nextAff = await getAffirmationFresh();
    const FALLBACKS = [
      "I am grounded, grateful, and growing.",
      "Creativity flows through me with ease.",
      "I choose courage over comfort today.",
      "I trust the timing of my life.",
      "I am worthy of the dreams I’m building.",
      "Small steps create big change.",
      "I honor my energy and my pace.",
      "I am open to unexpected magic.",
      "My presence is my power.",
      "I create beauty and meaning today.",
    ];
    if (!nextAff || nextAff === before) {
      let i = Math.floor(Math.random() * FALLBACKS.length);
      if (FALLBACKS[i] === before) i = (i + 1) % FALLBACKS.length;
      nextAff = FALLBACKS[i];
    }
    if (affEl) affEl.textContent = `"${nextAff}"`;
    safeStorage.setItem(KEYS.AFFIRMATION, nextAff);
  }

  function initMusicControls() {
    if (!audio || !toggle) return;
    let playing = false;
    toggle.onclick = () => {
      if (!audio.src) { alert("Music will be available after files are added. 🎵"); return; }
      if (!playing) {
        audio.play().then(() => {
          toggle.textContent = "🔇 Pause Music";
          toggle.classList.add("btn-primary");
          toggle.classList.remove("btn-ghost");
          playing = true;
        }).catch(() => {});
      } else {
        audio.pause();
        toggle.textContent = "🎵 Play Music";
        toggle.classList.remove("btn-primary");
        toggle.classList.add("btn-ghost");
        playing = false;
      }
    };
  }

  // Seed & wire
  loadDailyBackground();
  loadDailyMusic();
  initMusicControls();
  displayAffirmation();
  if (refresh) refresh.onclick = refreshInspiration;
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}

/* Optional: CSS fallback (static image) if JS is blocked)
   Add this to the section <style> if you want a guaranteed default:
   #affirmation-app #bg{ background-image:url("https://cdn.shopify.com/s/files/1/0766/5051/2700/files/TealTan.png?v=1761659612"); }
*/

